module.exports = __webpack_public_path__ + "static/background-image-l-76cdccf097cc9e5161f1d39ec689c33e.webm";